// extracted by mini-css-extract-plugin
module.exports = {"teamPositioner":"InviteMemberDialog_teamPositioner__k2ux1","content":"InviteMemberDialog_content__fo964","roles":"InviteMemberDialog_roles__fv1dV"};